import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';


const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
  // テンプレート一覧
  const [ templateOwners, setTemplateOwners ] = useState([]);
  // 選択中のカテゴリ
  const [ checkedTemplateId, setCheckedTemplateId ] = useState(0);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // 初回ロード
  useEffect(() =>{
    setIsLoading(true);
    setErrorMessage("");
    axios.get(
      '/api/internal/template_owners/get_template_owners', {}
    ).then(function (response) {
      setTemplateOwners(response.data.m_template_owners);
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }).finally(() => {
      setIsLoading(false);
    });
  },[])

  // 更新
  function submitTemplateOwner(){
    setIsLoading(true);
    setErrorMessage("");
    axios.post(
      '/api/internal/template_owners/update', { templateOwners: templateOwners, currentUser: props.current_m_user }
    ).then(function () {
      location.href = ("/templates/index");
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }).finally(() => {
      setIsLoading(false);
    });
  }

  // テンプレート並び替え
  function moveRow(type){
    if(checkedTemplateId === 0) return;

    const templateOwnersDup = templateOwners.slice();
    const targetIndex = templateOwnersDup.findIndex(template_owner => template_owner.m_template_id === checkedTemplateId);

    switch(type){
      case "up":
        if(targetIndex === 0) return;
        templateOwnersDup.splice( targetIndex - 1, 2, templateOwnersDup[targetIndex], templateOwnersDup[targetIndex - 1]);
        break;
      case "down":
        if(targetIndex === (templateOwnersDup.length - 1)) return;
        templateOwnersDup.splice( targetIndex, 2, templateOwnersDup[targetIndex + 1], templateOwnersDup[targetIndex]);
        break;
    }
    setTemplateOwners(templateOwnersDup);
  }

  // 表示切り替え
  function changeDelf(template_id, checked){
    const delf = checked ? 0 : 1
    setTemplateOwners(templateOwners.map((template_owner) => (template_owner.m_template_id === template_id ? {...template_owner, delf: delf} : template_owner)));
  }

  // 表示切り替え
  function changePatientView(template_id, checked){
    setTemplateOwners(templateOwners.map((template_owner) => (template_owner.m_template_id === template_id ? {...template_owner, is_patient_view: checked} : template_owner)));
  }

  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          {errorMessage}
        </div>
      }
        <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                    {/* テンプレート一覧 */}
                    <div className="form-group">
                        <h3>アンケート表示設定</h3>
                        <div className="text-left col-md-12 col-sm-12 col-xs-12">
                            アンケートを選択し「▲▼ボタン」を押すことで、先確認設定画面での表示順番を変更することができます。
                            <br/>
                            アンケート表示設定は店舗単位の設定になります。
                        </div>

                        <div className="text-left col-md-6 col-sm-6 col-xs-6 part-group-add">
                            {
                                checkedTemplateId　!= 0 &&
                                <>
                                    <a className="btn btn-primary mr10" onClick={()=> moveRow('up')}>▲</a>
                                    <a className="btn btn-primary mr10" onClick={()=> moveRow('down')}>▼</a>
                                </>
                            }

                        </div>
                        
                        <table id="notice_table" className="table table-bordered">
                            <thead>
                                <tr className="success">
                                    <th className="col-md-3 col-sm-3 col-xs-3 text-center">アンケート名</th>
                                    <th className="col-md-4 col-sm-4 col-xs-4 text-center">説明</th>
                                    <th className="col-md-1 col-sm-1 col-xs-1 text-center">所有者</th>
                                    <th className="col-md-2 col-sm-2 col-xs-2 text-center">患者受付</th>
                                    {
                                      props.m_institution.is_interview_unification && (
                                        <th className="col-md-2 col-sm-2 col-xs-2 text-center">共通QRコード</th>
                                      )
                                    }
                                    
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    templateOwners.map((template_owner, idx) => {
                                        const isChecked = template_owner.m_template_id === checkedTemplateId;
                                        return(
                                            <tr className={isChecked ? ("select-part-group") : ("")}>
                                                <td onClick={() => setCheckedTemplateId(template_owner.m_template_id)}>{template_owner.m_template_name}</td>
                                                <td onClick={() => setCheckedTemplateId(template_owner.m_template_id)}>{template_owner.m_template_description}</td>
                                                <td onClick={() => setCheckedTemplateId(template_owner.m_template_id)}>{template_owner.m_template_share_range_kbn === 0 ? "自社" : "共通"}</td>
                                                <td>
                                                  <div className="switchArea">
                                                    <input className="check"　value={1} type="checkbox" id={"m_template_owner_delf_" + idx} checked={template_owner.delf === 0} onChange={(e) => changeDelf(template_owner.m_template_id, e.target.checked)}/>
                                                    <label className="check-label" htmlFor={"m_template_owner_delf_" + idx}>
                                                      <span></span>
                                                    </label>
                                                    <label htmlFor={"m_template_owner_delf_" + idx} id="swImg" />
                                                  </div>
                                                </td>
                                                {
                                                  props.m_institution.is_interview_unification &&
                                                    <td>
                                                      <div className="switchArea">
                                                        <input className="check" disabled={template_owner.template_kbn === 30} value={"true"} type="checkbox" id={"m_template_owner_is_patient_view_" + idx}  checked={template_owner.is_patient_view === true} onChange={(e) => changePatientView(template_owner.m_template_id, e.target.checked)}/>
                                                        <label className="check-label" htmlFor={"m_template_owner_is_patient_view_" + idx}>
                                                          <span/>
                                                        </label>
                                                        <label htmlFor={"m_template_owner_is_patient_view_" + idx} id="swImg" />
                                                      </div>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    {/* ボタン類 */}
                    <div>
                        <div className="actions mt40">
                            <a className="btn btn-primary pull-left m5" href="/templates/index">戻る</a>
                            <a className="btn btn-primary pull-right m5" onClick={() => submitTemplateOwner()}>
                                更新する
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </LoadingOverlay>
  )
}
export default Index;